import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { ROUTE } from '../data/content';
export function RouteSection() {
  return <section aria-labelledby="ruta" className="border-y-2 border-gold bg-ink" data-id="element-183" data-mp="9cjoorgb0vfb">
      <div className="mx-auto max-w-page px-3 py-5 text-center sm:px-6 sm:py-6" data-id="element-184" data-mp="9ago5dhizjwc">
        <Reveal data-id="element-185" data-mp="5ag9psuff8pa">
          <h2 id="ruta" className="font-display text-base font-black uppercase leading-tight text-white sm:text-xl lg:text-2xl" data-id="element-186" data-mp="58vhi9vl41ul">
            ⏱️ Menos búsqueda. Más aprendizaje con dirección.
          </h2>
          <p className="mx-auto mt-1.5 max-w-2xl font-body text-[0.76rem] font-medium leading-snug text-blush sm:text-[0.82rem]" data-id="element-187" data-mp="3mijs91pi1jci">
            En lugar de preguntarte qué estudiar después, avanzas por una ruta
            de 6 tomos:
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-2.5 flex max-w-4xl flex-wrap items-center justify-center gap-1" data-id="element-188" data-mp="1kpdrlsegibn8">
          {ROUTE.map((step, i) => <React.Fragment key={step} data-id="element-189" data-mp="myu1syayxxb6" data-mpi={i}>
              <span className="rounded-full bg-coral px-2.5 py-1 text-[0.66rem] font-extrabold uppercase tracking-wide text-white sm:px-3 sm:text-[0.76rem]" data-id="element-190" data-mp="ryylsyb35a65">
                {step}
              </span>
              {i < ROUTE.length - 1 && <ChevronRightIcon size={13} aria-hidden="true" className="text-gold" strokeWidth={3} data-id="element-191" data-mp="i1kdxn389tpg" />}
            </React.Fragment>)}
        </Reveal>
      </div>
    </section>;
}